import React from 'react';
import PropTypes from 'prop-types';
import ArrowCircleRight from '../../../../../../../assets/img/arrow_circle_right.svg';

const WorkExpEstTime = ({ btnState, onButtonClicked, gb_seniority_improvement_conversion }) => {
  return gb_seniority_improvement_conversion === 'sic_banner_change' ? (
    <div className="new-mcq-work-exp-est-time-wrapper-new" onClick={onButtonClicked}>
      <div>
        <div className='est-time-text-small'>Estimated time:</div>
        <div className='est-time-text-medium'>15 minutes</div>
      </div>
      <hr className='est-time-hr' color='#56A8F7' size='1' />
      <div>
        <div className='est-time-button'>
          { btnState === 'Start now' ? 'Start Survey Now' : 'Continue Survey' } <img className='est-time-button-icon' src={ArrowCircleRight} />
        </div>
      </div>
    </div>
  ) : (
    <div className="new-mcq-work-exp-est-time-wrapper">
      <div className="new-mcq-work-exp-text"><span>Work</span><br/><span>Experience</span><br/><span>Survey</span></div>
      <div className="new-mcq-work-exp-est-time-text">Est. time</div>
      <div className="new-mcq-work-exp-est-time">30 min</div>
    </div>
  );
};

WorkExpEstTime.propTypes = {
  btnState: PropTypes.string,
  onButtonClicked: PropTypes.func,
  gb_seniority_improvement_conversion: PropTypes.string
};
export default WorkExpEstTime;
